import { Flex } from 'components/Flex/Flex';
import styled from 'styled-components';

export const SectionLabel = styled.span`
  ${({ theme }) => theme.fonts.PoppinsTextBold};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 16px;
  line-height: 24px;
`;

export const ShiftCardList = styled(Flex)`
  flex-direction: column;
  gap: 16px;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const ShiftCardWrapper = styled(Flex)`
  align-items: flex-start;
  gap: 24px;
  padding: 16px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.Grey1};
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.Grey2};
  }
`;

export const ShiftIdText = styled.span`
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  color: ${({ theme }) => theme.colors.TextSubtleGrey};
  font-size: 14px;
  line-height: 21px;
  white-space: nowrap;
`;

export const PositionText = styled.span`
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  color: ${({ theme }) => theme.colors.PrimaryDefault};
  font-size: 14px;
  line-height: 21px;
`;

export const CardText = styled.span`
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  font-size: 14px;
  line-height: 21px;
`;
